import { TypeWithKey } from '../../models'

export const getValidationError = (errorCode: any) => {
  const codeMatcher: TypeWithKey<string> = {
    'user/userPersistenceServices':
      'Correo electrónico o contraseña incorrecta.',
    'user/sessionExpired': '¡La sesión ha expirado!.',
    'user/CodeMismatchException':
      'El código de acceso proporcionado no coincide, intenta nuevamente.',
    'user/LimitExceededException':
      'Numero de intentos agotados, intenta de nuevo mas tarde.',
    'password/insecure':
      'La contraseña debe tener al menos 6 caracteres, contener al menos una letra mayúscula, y un número.',
    'payrolls/integration/integration-not-found':
      'No se han encontrado la integración',
    'payrolls/client/internal-error':
      'Error del servidor. Contacta con un administrador.',
    'payrolls/client/Client-not-found': 'Cliente no encontrado.',
    'payrolls/client/missing-required-field':
      'Los campos de la integración son requeridos',
    'payrolls/client/Client-code-no-allowed': 'Código no admitido',
    'payrolls/client/invalid-field-type':
      'Se deben de respetar los tipos de datos de los campos.',
    'payrolls/client/client-not-inactive':
      'No puedes eliminar un cliente activo.',
    'payrolls/client/Client-already-exist': 'Cliente ya existe en el sistema.',
    'payrolls/modules/module-not-exist':
      'Uno de los modulos ingresados no existe.',
    'payrolls/client/integration-failed':
      'La integración ha fallado. Contacta con un administrador.',
    'payrolls/payrollsConfig/Payroll-config-not-exist':
      'La configuración de nóminas no existe.',
    'payrolls/payrollsConfig/payroll-already-assgined':
      'Una de las nóminas ya ha sido asignada a un grupo de configuración',
    'auth/no-token': 'No se proporcionó un token en la solicitud.',
    'auth/session-expired': 'La sesión ha expirado.',
    'auth/unauthorized': 'Sin suficientes permisos para ejecutar la acción.',
    'auth/auth-error': 'Error al verificar el token.',
    'auth/users/username-already-exists':
      'Yá existe un usuario con el correo electronico proporcionado.',
    'user/employee-id-required-on-user-creation':
      'El campo empleado es requerido al crear un usuario de tipo empleado.',
    'auth/users/username-not-found':
      'No fue encontrado un usuario con el nombre de usuario proporcionado.',
    'auth/role/role-not-found': 'El rol no fue encontrado.',
    'payrolls/employee/employee-not-exist': 'Empleado no encontrado.',
    'approver/approver/approver-not-assigned':
      'No se ha asignado un aprobador.',
    'approval-flow/request/approver-not-found':
      'No se ha encontrado un aprobador.',
    'server-error': 'Error del servidor.',
    'receipts/integration/employee-no-has-salary':
      'El empleado no tiene salario.',
    'payrolls/company/company-not-inactive':
      'No puedes eliminar una empresa activa.',
    'approval-flow/approval-flow/approva-flow-not-found':
      'No se ha encontrado un flujo de aprobación configurado.',
    'workingdays/working-day-not-assigned':
      'No se han asignado días laborales. contacta con un administrador.',
    'approval-flow/approval-flow-request/approva-flow-request-not-found':
      'La Solicitud ha sido eliminada.',
    'receipts/payroll-receipts/payroll-receipts-not-found':
      'No se han encontrado recibos de nómina.',
    'letters/letter-config-not-found':
      'No se ha encontrado la configuración de la carta.',
    'letters/letter-not-found': 'No se ha encontrado la carta.',
    'letters/letter-already-exist': 'La carta ya existe.',
    'user/inactive':
      'Tu cuenta no está activa. Contacta a tu administrador para más información.',
    'employee/inactive':
      'Tu cuenta no está activa. Contacta a tu administrador para más información.',
    'not-found-error': 'No se encontró el recurso solicitado.',
    'payrolls/client/file-format-not-valid':
      'El formato del archivo no es válido.',
    'user/invalid-parameter-exception':
      'No se puede restablecer la contraseña del usuario porque no hay un correo electrónico registrado/verificado.',
    'user/ExpiredCodeException':
      'El código de verificación ha expirado, por favor intenta nuevamente.',
    ERR_NETWORK: 'Se rompió la red',
    ERR_TIMEOUT: 'Se acabó el tiempo',
    ERR_CANCEL: 'Se canceló la petición',
    ERR_UNKNOWN: 'Error desconocido',
    ERR_400: 'Error 400',
    ERR_401: 'Error 401',
    ERR_403: 'Error 403',
  }

  return codeMatcher[errorCode]
}
